import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { ClipLoader } from "react-spinners";
import { Modal, ShareModalProps } from "ui";

import { useGetParcelSizes, useUpdateParcelSizes } from "../../../apis";
import {
  getInitialParcelSizesFormValues,
  getUpdateParcelSizesRequestBody
} from "../../../helpers";
import { ParcelSizesForm } from "../../forms";

import styles from "./ParcelSizesModal.module.scss";

const PARCEL_SIZES_FORM_ID = "parcel-sizes-form-id";

const ParcelSizesModal = ({ isOpen, onClose }: ShareModalProps) => {
  const { t } = useTranslation();
  const { parcelSizes, refetch, isLoading } = useGetParcelSizes();

  const updateParcelSizes = useUpdateParcelSizes({
    onSuccess: () => {
      refetch();
      toast.success(t("Parcel Sizes updated successfully"));
    }
  });

  return (
    <Modal
      formId={PARCEL_SIZES_FORM_ID}
      isOpen={isOpen}
      title={t("Parcel sizes")}
      isLoading={updateParcelSizes.isLoading}
      okText={t("Save")}
      className={styles.modal}
      onClose={onClose}
    >
      {isLoading && (
        <div className={styles.loader}>
          <ClipLoader size={50} color="#fb3973" />
        </div>
      )}

      {parcelSizes && (
        <ParcelSizesForm
          defaultValues={getInitialParcelSizesFormValues(parcelSizes)}
          formId={PARCEL_SIZES_FORM_ID}
          onSubmit={(values) =>
            updateParcelSizes.mutate(getUpdateParcelSizesRequestBody(values))
          }
        />
      )}
    </Modal>
  );
};

export default ParcelSizesModal;
